import type { ResumeDto } from "@izicvs/dto";
import { AnimatePresence, motion } from "framer-motion";

import { BaseCard } from "./_components/base-card";
import { ResumeCard } from "./_components/resume-card";

type Props = {
  resumes: ResumeDto[];
  loading: boolean;
};

export const GridView = ({ resumes, loading }: Props) => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6 xl:grid-cols-4 2xl:grid-cols-5">
    {loading &&
      Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="duration-300 animate-in fade-in"
          style={{ animationFillMode: "backwards", animationDelay: `${i * 120}ms` }}
        >
          <BaseCard />
        </div>
      ))}

    <AnimatePresence>
      {resumes.map((resume, index) => (
        <motion.div
          key={resume.id}
          layout
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0, transition: { delay: Math.min(index, 8) * 0.03 } }}
          exit={{ opacity: 0, filter: "blur(8px)", transition: { duration: 0.4 } }}
        >
          <ResumeCard resume={resume} />
        </motion.div>
      ))}
    </AnimatePresence>
  </div>
);
